// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "* {\r\n  font-family: 'Rubik', sans-serif;\r\n  padding: 0;\r\n  margin: 0;\r\n  color: #183b56;\r\n}\r\n.container{\r\n  width: 100%;\r\n  max-width: 95%;\r\n}\r\n\r\nmain {\r\n  min-height: 100vh;\r\n  margin-top: 150px;\r\n\r\n}\r\n\r\n.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6{\r\n    margin-top: 0;\r\n    margin-bottom: 0.5rem;\r\n    font-weight: 500;\r\n    line-height: 1.2;\r\n}\r\n\r\n@media (max-width: 991px){\r\n  main {\r\n    margin-top: 20px;\r\n  \r\n  }\r\n}", ""]);
// Exports
module.exports = exports;
